// Abuse reports. The reporter pastes a share link; we strip the #fragment
// (the decryption key) before it goes anywhere, so a report never grants
// access to the secret — including to us.

export const ABUSE_EMAIL = 'abuse@simplesecretsharing.com';

/** The link without its fragment, or null if `input` isn't an http(s) URL. */
export const reportableLink = (input: string): string | null => {
  let url: URL;
  try {
    url = new URL(input.trim());
  } catch {
    return null;
  }
  if (url.protocol !== 'https:' && url.protocol !== 'http:') return null;
  url.hash = '';
  return url.toString();
};

export const abuseMailto = (link: string, details: string, subject: string): string => {
  const params = new URLSearchParams({ subject, body: `Reported link: ${link}\n\n${details.trim()}\n` });
  // mailto bodies need %20, not '+', for spaces.
  return `mailto:${ABUSE_EMAIL}?${params.toString().replace(/\+/g, '%20')}`;
};
